<template>
  <div id="tabla-resumen">
    <v-data-table
      :headers="headers"
      :items="pagos"
      :page-count="pagos.last_page"
      :page="pagos.current_page"
      :server-items-length="pagos.total"
      :sort-by="sortby"
      :sort-desc="sortdesc"
      :footer-props="{
        itemsPerPageOptions: [10]
      }"
      @update:options="getData($event)"
      @click:row="handleClick"
    >
      <template #item="{ item }">
        <tr>
          <td class="text-start">
            <div @click="handleClick(item)">
              {{ item.fecha }}
            </div>
          </td>
          <td class="text-center">
            <div @click="handleClick(item)">
              {{ setDescripcion(item) }}
            </div>
          </td>
          <td class="text-end">
            <div
              :class="item.monto < 0 ? 'negativo' : 'positivo'"
              @click="handleClick(item)"
            >
              {{ item.monto }}
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import GeneradorPdfRecibojs from '../../mixins/generadorPdfRecibo'

  export default {
    name: 'ResumenCuentaCorrienteTabla',
    mixins: [GeneradorPdfRecibojs],
    props: {
      monedaId: {
        type: Number,
        default: 0,
        required: true,
      },
      urlparametrizada: {
        type: String,
        default: '?page=&fechaDesde=&fechaHasta=&jugadorId=',
        required: false,
      },
    },
    data () {
      return {
        headers: [
          { text: 'Fecha', align: 'start', sortable: true, value: 'fecha' },
          { text: 'Descripción ', align: 'center', sortable: false, value: 'descripcion' },
          { text: 'Monto ', align: 'end', sortable: false, value: 'monto' },
        ],
        op: {},
        sortby: [],
        sortdesc: [true],
        pagos: [],
      }
    },
    watch: {
      urlparametrizada () {
        this.getRecibosAndPagos(1, this.op.sortBy, this.op.sortDesc)
      },
    },
    methods: {
      handleClick (item) {
        if (item.tipo === 'Recibo') {
          this.generarPdfRecibo(item.numero)
        }
        if (item.tipo === 'Pago') {
          this.generarPdfPago(item.numero)
        }
        // if (item.tipo === 'Solicitud extraordinaria') {
        //  this.$router.push({ name: 'Alta viaticos', params: { mode: 'show', id: item.numero } })
        // }
      },

      getData: function (data) {
        this.op = data
        this.getRecibosAndPagos(data.page, data.sortBy, data.sortDesc)
      },

      hayPagos () {
        if (this.pagos.length > 0) {
          this.$emit('hayPagos', true)
        } else {
          this.$emit('hayPagos', false)
        }
      },

      setTotal () {
        var total = this.pagos.reduce((a, b) => +a + +b.monto, 0).toFixed(2)
        this.$emit('total', total)
      },

      setDescripcion (item) {
        if (item.tipo === 'Recibo') {
          return 'Recibo N° ' + (('00000000' + item.numero).slice(-8))
        } else {
          return item.descripcion
        }
      },

      currentPagos () {
        this.$emit('currentPagos', this.pagos)
      },

      getRecibosAndPagos: async function (page = 1, sortBy, sortDesc) {
        this.$store.dispatch('axiosMod/getData', { url: '/api/pago_recibo_jugador/' + this.monedaId + '?page=' + page + this.urlparametrizada + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc }).then(response => {
          this.pagos = response
          this.hayPagos()
          this.setTotal()
        })
      },
    },
  }
</script>

<style>
  .positivo
  {
    color:rgb(0, 177, 106) !important;
    font-size: 16px !important;
  }
  .negativo
  {
    color:rgb(240, 52, 52) !important;
    font-size: 16px !important;
  }
</style>
